export interface IPendingRegistrationDonor {
    id: number,
    requestId: number,
    donorId: number,
    donorAlias: string,
    donorName: string,
    donorEmail: string,
    organType: number,
    donationType: number,
    isDsdOnly: boolean,
    watrRequestType: number,
    isInternational: boolean,
    donationDate: string
}
